module.exports = require("json2csv");


//////////////////
// WEBPACK FOOTER
// external "json2csv"
// module id = 3
// module chunks = 0